import { Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { Icon } from "./icon";

@Component({
    selector: 'app-alert',
    imports: [NgClass, Icon],
    template: `
ì    <div
      role="alert"
      class="alert w-auto min-w-72 max-w-lg fixed bottom-5 z-50 left-1/2 translate-x-[-50%]"
      [ngClass]="{
          'alert-info': variant() === 'info',
          'alert-success': variant() === 'success',
          'alert-error': variant() === 'error',
        }"
    >
    @if(variant()) {
        <app-icon [iconName]="variant() === 'info' ? 'infoCircle' : variant() === 'success' ? 'check' : 'close'" stroke="white" className="w-6 h-6"/> 
    }
        <div class="w-full text-white text-base">
            <ng-content></ng-content>
        </div>
    </div>`,
    styles: ``,
})
export class Alert {
    variant = input<'info' | 'success' | 'error' | undefined>();
}
